<div class="filters-container">

    <mat-form-field appearance="outline">
        <mat-label>Type d'entité</mat-label>
        <mat-select [(ngModel)]="filters.entityType" (selectionChange)="onFilterChange()">
            <mat-option *ngFor="let opt of entityTypeOptions" [value]="opt.value">
                {{ opt.label }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
        <mat-label>Type d'action</mat-label>
        <mat-select [(ngModel)]="filters.operation" (selectionChange)="onFilterChange()">
            <mat-option *ngFor="let opt of operationOptions" [value]="opt.value">
                {{ opt.label }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
        <mat-label>Rôle utilisateur</mat-label>
        <mat-select [(ngModel)]="filters.role" (selectionChange)="onFilterChange()">
            <mat-option *ngFor="let opt of roleOptions" [value]="opt.value">
                {{ opt.label }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
        <mat-label>Date début</mat-label>
        <input matInput [matDatepicker]="picker1" name="dateFrom"
               [(ngModel)]="filters.dateFrom" (dateChange)="onFilterChange()">
        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
        <mat-datepicker #picker1></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline">
        <mat-label>Date fin</mat-label>
        <input matInput [matDatepicker]="picker2" name="dateTo"
               [(ngModel)]="filters.dateTo" (dateChange)="onFilterChange()">
        <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
        <mat-datepicker #picker2></mat-datepicker>
    </mat-form-field>

</div>

<div class="data-header">
    <mat-form-field class="filter-field">
      <mat-label>Filtre</mat-label>
      <input matInput (keyup)="applyFilter($event)">
    </mat-form-field>
  </div>


<div class="table-wrapper">
  <mat-table
    [dataSource]="fichesFiltrees"
    class="mat-elevation-z4 light table"
    
    id="audit-table"
  >

  <!-- Entity -->
  <ng-container matColumnDef="entityNumber">
    <mat-header-cell *matHeaderCellDef>Numéro d'entité</mat-header-cell>
    <mat-cell *matCellDef="let element">{{ getEntityNumber(element) }}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="entityType">
    <mat-header-cell *matHeaderCellDef>Entité</mat-header-cell>
    <mat-cell *matCellDef="let element">{{element.entityType}}</mat-cell>
  </ng-container>

  <!-- Operation -->
  <ng-container matColumnDef="operation">
    <mat-header-cell *matHeaderCellDef>Action</mat-header-cell>
    <mat-cell *matCellDef="let element">
      <span class="badge">{{getActionLabel(element.operation)}}</span>
    </mat-cell>
  </ng-container>

  <!-- User -->
  <ng-container matColumnDef="user">
    <mat-header-cell *matHeaderCellDef>Utilisateur</mat-header-cell>
    <mat-cell *matCellDef="let element">
      {{element.actorDisplayName}} ({{element.actorRole}})
    </mat-cell>
  </ng-container>

<ng-container matColumnDef="changes">
  <mat-header-cell *matHeaderCellDef>Changements</mat-header-cell>
  <mat-cell *matCellDef="let element">
    <div class="changed-fields">
      <ng-container *ngFor="let change of getChangedFieldsMap(element.changedFields, element.entityType)">
        <div class="changed-field-row">
          <span class="field-label">{{ change.label }}</span>
          <span class="value before">{{ change.before }}</span>
          <span class="arrow">→</span>
          <span class="value after">{{ change.after }}</span>
        </div>
      </ng-container>
      <span *ngIf="!element.changedFields" class="no-changes">—</span>
    </div>
  </mat-cell>
</ng-container>

<ng-container matColumnDef="motifRetourArriere">
  <mat-header-cell *matHeaderCellDef>Motif retour en arrière</mat-header-cell>

  <mat-cell *matCellDef="let element">

    <ng-container *ngIf="getMotifRetourArriere(element.changedFields) as motif; else noMotif">

      <div class="motif-item">
        {{ motif }}
      </div>

    </ng-container>

    <ng-template #noMotif>
      --
    </ng-template>

  </mat-cell>
</ng-container>

<ng-container matColumnDef="motifRefus">
  <mat-header-cell *matHeaderCellDef>Motif de refus</mat-header-cell>

  <mat-cell *matCellDef="let element">

    <ng-container *ngIf="getMotifRefus(element.changedFields) as motif; else noMotif">

      <div class="motif-item">
        {{ motif }}
      </div>

    </ng-container>

    <ng-template #noMotif>
      --
    </ng-template>

  </mat-cell>
</ng-container>


  <!-- Date -->
  <ng-container matColumnDef="createdAt">
    <mat-header-cell *matHeaderCellDef>Date</mat-header-cell>
    <mat-cell *matCellDef="let element">
      {{element.createdAt | date:'short'}}
    </mat-cell>
  </ng-container>

  <!-- Columns -->
  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
<mat-row *matRowDef="let row; columns: displayedColumns"
         (click)="openAuditDetail(row)"
         class="clickable-row"></mat-row>
  <ng-template matNoDataRow>
    <div class="no-data">Aucun audit trouvé</div>
  </ng-template>

</mat-table>

</div>

<div class="paginator-container">
  <mat-paginator
    [length]="totalElements"
    [pageSize]="pageSize"
    [pageIndex]="pageIndex"
    [pageSizeOptions]="[5, 10, 25, 50, 100]"
    [showFirstLastButtons]="true"
    (page)="onPageChange($event)">
  </mat-paginator>
</div>